import React from 'react';
import PropTypes from 'prop-types';
import style from '@src/js/Style';
import Button from '../Base/Button';
import Card from '../Base/Card';
import Translation from '../Base/Translation';

export default class OfficeTable extends React.Component {

    constructor(props) {

        super(props);

        this.page = 0;
        this.numberOfPages = 0;
        this.state = {};
    }

    componentDidMount() {

        this.loadItems();
    }

    static get propTypes() {

        return {
            title: PropTypes.string,
            subtitle: PropTypes.string,
            columnBankLabel: PropTypes.string,
            columnMaxSumLabel: PropTypes.string,
            columnRateLabel: PropTypes.string,
            columnAddressLabel: PropTypes.string,
            countryId: PropTypes.any,
            categoryId: PropTypes.any,
            companyId: PropTypes.any,
            cityId: PropTypes.any,
        };
    }

    render() {

        return (
            <section className={ style('w-full mt-4 mb-12 p-0') }>
                <center>
                    <h2 className={ style('title2') }>{ this.props.title }</h2>
                    <div dangerouslySetInnerHTML={{ __html: this.props.subtitle }}></div>
                    <Card className={ style('w-full mt-8') }>
                        <div className={ style('table-responsive') }>
                            <table className={ style('table') }>
                                <thead>
                                    <tr>
                                        <th>{ this.props.columnBankLabel }</th>
                                        <th>{ this.props.columnMaxSumLabel }</th>
                                        <th>{ this.props.columnRateLabel }</th>
                                        <th>{ this.props.columnAddressLabel }</th>
                                    </tr>
                                </thead>
                                <tbody>{ this.state?.items ?? [] }</tbody>
                            </table>
                        </div>
                    </Card>
                    { this.renderButton() }
                </center>
            </section>
        );
    }

    loadItems() {

        this.page++;

        const link = new URL(`${window.location.origin}/api/v2/aggregation/offices.json`);
        link.searchParams.append('country_id', this.props.countryId);
        link.searchParams.append('category_id', this.props.categoryId);
        link.searchParams.append('company_id', this.props.companyId ?? null);
        link.searchParams.append('city_id', this.props.cityId ?? null);
        link.searchParams.append('page', this.page);

        fetch(link.toString())
            .then((response) => response.json())
            .then((response) => {

                const items = this.state?.items ?? [];
                if (response.success) {

                    response.context.items?.forEach((offer) => {

                        items.push(this.renderItem(offer));
                    });
                }

                this.numberOfPages = response.context.numberOfPages;
                this.setState({ items });
            });
    }

    renderItem(offer) {

        return (
            <tr key={ offer.office.id }>
                <td className={ style('flex flex-wrap items-center gap-md') }>
                    { this.renderItemIcon(offer) }
                    <a href={ offer.office.uri }>{ offer.office.name }</a>
                </td>
                <td>{ offer.product.sum }</td>
                <td>{ offer.product.rate }</td>
                <td>{ offer.office.city.name }, { offer.office.address }</td>
            </tr>
        );
    }

    renderItemIcon(offer) {

        if (offer.office.company.icon)
            return <img
                className={ style('size-24 aspect-square object-contain') }
                src={ offer.office.company.icon }
                alt={ offer.office.company.name } />;

        return null;
    }

    renderButton() {

        if (this.page < this.numberOfPages) {

            return (
                <Button
                    onClick={ () => this.loadItems() }
                    style='outline'
                    className={ style('mt-8 mobile:w-full') }>
                        <Translation tag='blog.loadmore' />
                </Button>
            );
        }
        
        return null;
    }

}